import { FormComponentEnums } from "shared/types/enums";
import ButtonInput from "shared/components/forms/buttons/ButtonInput";

const SubmitButton = ({ isLastStep }: { isLastStep: boolean }) => (
  <ButtonInput
    className="control-button next-button"
    id="next-submit-button"
    type={FormComponentEnums.Submit}
    label={isLastStep ? "Submit" : "Next"}
  />
);

export default SubmitButton;
